import { AlertCircleIcon } from 'lucide-react'
import type { ReactNode } from 'react'

export const UnknownContentFallback: React.FC = (): ReactNode => (
  <div className="split-view-fallback flex h-full flex-col items-center justify-center gap-2 p-4 text-muted-foreground">
    <AlertCircleIcon className="size-8 text-muted-foreground/50" />
    <p>Unknown content type</p>
  </div>
)

export const NoContentFallback: React.FC = (): ReactNode => (
  <div className="split-view-empty flex h-full items-center justify-center p-4 text-muted-foreground">
    <p>No content to display</p>
  </div>
)

export const InvalidDataFallback: React.FC = (): ReactNode => (
  <div className="split-view-invalid flex h-full flex-col items-center justify-center gap-2 p-4 text-muted-foreground">
    <AlertCircleIcon className="size-8 text-destructive/50" />
    <p>Invalid content data</p>
  </div>
)
